export const QUOTE_SEARCH_THRESHOLD = 6
